import { render, staticRenderFns } from "./setAdmin.vue?vue&type=template&id=647fa7ce&scoped=true"
import script from "./setAdmin.vue?vue&type=script&lang=js"
export * from "./setAdmin.vue?vue&type=script&lang=js"
import style0 from "./setAdmin.vue?vue&type=style&index=0&id=647fa7ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647fa7ce",
  null
  
)

export default component.exports